<div class="modal-overlay" (click)="onOverlayClick($event)">
  <div
    class="modal-container"
    [class.modal-container--mobile-sheet]="mobileSheet"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="titleId"
    [attr.aria-busy]="busy ? 'true' : null"
    [attr.data-testid]="testId"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    (click)="$event.stopPropagation()"
  >
    <div class="modal-header">
      <h2 [id]="titleId" [attr.data-testid]="testId + '-title'">{{ title }}</h2>
      <button
        type="button"
        class="close-button"
        aria-label="Close"
        [attr.data-testid]="testId + '-close-button'"
        [disabled]="busy"
        (click)="onCancel()"
      >
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <path
            d="M13 1L1 13M1 1L13 13"
            stroke="#555963"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <div class="modal-body">
      <p *ngIf="message" [attr.data-testid]="testId + '-message'">{{ message }}</p>
      <ng-content></ng-content>
    </div>

    <div class="modal-footer">
      <ng-content select="[modalFooterExtra]"></ng-content>
      <button
        *ngIf="showCancel"
        type="button"
        class="btn btn-large"
        [ngClass]="cancelButtonClass"
        [attr.data-testid]="testId + '-cancel-button'"
        [disabled]="busy"
        (click)="onCancel()"
      >
        {{ cancelLabel }}
      </button>
      <button
        type="button"
        class="btn btn-primary btn-large"
        [ngClass]="confirmButtonClass"
        [attr.data-testid]="testId + '-confirm-button'"
        [disabled]="busy || confirmDisabled"
        (click)="onConfirm()"
      >
        {{ primaryLabel }}
      </button>
    </div>
  </div>
</div>
